var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.layoutName,{tag:"component",attrs:{"materials":_vm.materials},on:{"ads:click":_vm.adsOnClick,"ads:view":_vm.adsOnView,"ads:entry":_vm.adsOnEntry}})}
var staticRenderFns = []

export { render, staticRenderFns }